module.exports = __webpack_public_path__ + "static/media/plat.3295710e.mp4";